import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Tag = styled.div<{ color?: string; backgroundColor?: string; clickable?: string }>`
  background: ${(props) =>
    props.backgroundColor ? props.backgroundColor : props.theme.color.light.default};
  color: ${(props) => (props.color ? props.color : props.theme.color.blue.default)};
  cursor: ${(props) => (props.clickable === 'true' ? 'pointer' : 'unset')};
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 7px;

  width: auto;
  ${mediaQuery('small')} {
    font-size: 12px;
  }
`;
